import useDefinedContext from "hooks/useDefinedContext";
import ExercisesContext from "../ExercisesContext";

function useExercises() {
  const enabledExercises = useDefinedContext(ExercisesContext);

  return enabledExercises;
}

export default useExercises;
